<div class="body-2 p-6 bg-primary-600 text-on-primary-600">
  <p>היום</p>
  <div class="display-1">{{ dayName }}</div>
  <div class="display-1">{{ date }}</div>
</div>

<mat-divider></mat-divider>

<mat-nav-list>
  <h3 matSubheader>אירועים קרובים</h3>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>פגישת עסקים</h4>
    <p matListItemLine>בעוד 16 דקות, חדר ישיבות</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>בקשת חופשה</h4>
    <p matListItemLine>12:00</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>ארוחת ערב עם סופי</h4>
    <p matListItemLine>18:30</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>מועד סופי לפרויקט X</h4>
    <p matListItemLine>21:00</p>
  </a>
  <mat-divider></mat-divider>
  <h3 matSubheader>רשימת משימות</h3>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>הזמן את ג'ק למשחק גולף</h4>
    <p matListItemLine>נוסף: לפני 6 שעות</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>למד עוד על Angular</h4>
    <p matListItemLine>נוסף: לפני יומיים</p>
  </a>
  <a [routerLink]="[]" mat-list-item>
    <h4 matListItemTitle>הגדר את הראוטר החדש</h4>
    <p matListItemLine>נוסף: לפני 5 ימים</p>
  </a>
  <mat-divider></mat-divider>
  <h3 matSubheader>נתוני שרת</h3>
</mat-nav-list>

<div class="vex-list-item" matRipple>
  <p>עומס מעבד (71% / 100%)</p>
  <p class="progress-bar">
    <mat-progress-bar
      [value]="71"
      color="primary"
      mode="determinate"></mat-progress-bar>
  </p>
</div>

<div class="vex-list-item" matRipple>
  <p>ניצול זיכרון (6,175MB / 16,384MB)</p>
  <p class="progress-bar">
    <mat-progress-bar
      [value]="34"
      color="accent"
      mode="determinate"></mat-progress-bar>
  </p>
</div>

<div class="vex-list-item" matRipple>
  <p>טמפ' מעבד (43° / 80°)</p>
  <p class="progress-bar">
    <mat-progress-bar
      [value]="54"
      color="warn"
      mode="determinate"></mat-progress-bar>
  </p>
</div>
